import styled from '@emotion/styled'

export const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

export const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

export const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 40px;
    min-height: 80vh;

    @media screen and (max-width: 500px) {
        padding: 16px;
    }
`

export const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media screen and (max-width: 500px) {
        flex-direction: column;
    }
`

export const flexWrap = {
    display: 'flex',
    flexWrap: 'wrap',
}

export const flexCenter = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
}

export const flexColumn = {
    display: 'flex',
    flexDirection: 'column',
}

export const flexBetween = {
    display: 'flex',
    justifyContent: 'space-between',
}

export const card = {
    mr: 4,
    mb: 4,
    maxWidth: '340px',
    width: '100%',
    border: '2px solid #F1F3F5',
    borderRadius: '8px',
    padding: 1,
    display: 'flex',
    flexDirection: 'column',
}

export const discount = {
    background: '#FDE1E2',
    padding: '4px',
    color: '#EA4353',
    borderRadius: '4px',
}

export const sloganBox = {
    color: '#676767',
    fontWeight: 400,
    mt: 1,
    mb: 2,
}

export const priceBox = {
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
}

export const moreBtn = {
    mr: 2,
    color: 'black',
    borderColor: 'black',
}

export const buttonBox = {
    mt: 4,
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: 1,
}

export const discountSloganBox = {
    display: 'flex',
    alignItems: 'start',
    color: '#E06800',
    fontWeight: 600,
    mr: '6px',
}

export const tagContainer = {
    display: 'flex',
    alignItems: 'center',
    mr: '4px',
    mb: '4px',
    border: '1px solid #E7E9ED',
    borderRadius: '4px',
    padding: '2px 4px',
}

export const tagIcon = {
    height: '14px',
    marginRight: '4px',
}

export const tagText = {
    whiteSpace: 'nowrap',
    color: '#787D8B',
    fontSize: '12px',
}

export const logo = {
    height: 60,
    width: 60,
    borderRadius: '50%',
    objectFit: 'cover',
}

export const price = {
    color: '#A0A1A5',
    border: '2px solid #A0A1A5',
    borderRadius: '4px',
    padding: '2px 6px',
    display: 'inline-block',
    mb: 1,
    fontWeight: 600,
    fontSize: '12px',
}

export const timerContainer = {
    width: '200px',
    border: '2px solid black',
    borderRadius: '8px',
    padding: '8px',
    position: 'relative',
    mr: 1,
}

export const discountTimer = {
    background: '#FDE1E2',
    padding: '4px',
    color: '#EA4353',
    borderRadius: '4px',
    position: 'absolute',
    top: '-10px',
    right: '-16px',
}

export const textCenter = {
    textAlign: 'center',
}

export const time = {
    fontSize: '20px',
    fontWeight: 500,
    mb: '2px',
}

export const timeTitle = {
    fontSize: '10px',
}

export const discountBox = {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#E5F4FF',
    padding: '16px',
    borderRadius: '16px',
    alignItems: 'center',
    mb: 2,

    '@media screen and (max-width: 500px)': {
        display: 'grid',
        gridTemplateColumns: 'auto',
    },
}

export const arrow = {
    mb: '20px', 
    cursor: 'pointer' 
}